import Button from "../Button/Bitton";
import { useTelegram } from "../../utils";

import LinkElement from "../LinkElement/LinkElement";

function MenuGroup() {
  const { onClose } = useTelegram({}, false);

  return (
    <>
      <Button title="Отменить" onClick={onClose}></Button>
      <LinkElement link="/feast" title="Заявка для банкетов"></LinkElement>
      <LinkElement link="/wake" title="Заявка для поминок"></LinkElement>
      <LinkElement link="/update" title="Заявка для регистрации"></LinkElement>
      <LinkElement link="/message" title="Написать сообщение"></LinkElement>
    </>
  );
}

export default MenuGroup;
